module.exports = __webpack_public_path__ + "static/media/user-bg.756250cb.jpg";